import React, { useEffect, useState} from 'react';
import { getCustomerSubscriptionDetails } from '../../api/endpoints/customer';
const SubscriptionWidget = ({ compId, customerId }) => {
  const [ currentData, setCurrentData ] = useState({});
  useEffect(() => {
    const fetchData = async () => {
      if(compId && customerId ){
        const response = await getCustomerSubscriptionDetails(compId, customerId);
        if(response.status === 200){
          const accData = response.data.data;
          setCurrentData(accData);
        }          
      }
    };
    fetchData();
    },[customerId]);

  return (
    <div className="row">
      <div className="col-lg-4">
        <div className="card">
            <div className="card-body">
                <h5 className="fs-16 fw-semibold">{currentData.credit}</h5>
                <p className="text-muted">Credit Left</p>
            </div>
            <div className="progress animated-progress rounded-bottom rounded-0" style={{height: "6px"}}>
                <div className="progress-bar bg-success rounded-0" role="progressbar" style={{ width: "30%"}} aria-valuenow="30" aria-valuemin="0" aria-valuemax="100"></div>
                <div className="progress-bar bg-info rounded-0" role="progressbar" style={{ width: "50%" }} aria-valuenow="50" aria-valuemin="0" aria-valuemax="100"></div>
                <div className="progress-bar rounded-0" role="progressbar" style={{ width: "20%"}} aria-valuenow="20" aria-valuemin="0" aria-valuemax="100"></div>
            </div>
          </div>
      </div>
      <div className="col-lg-4">
        <div className="card">
            <div className="card-body">
                <h5 className="fs-16 fw-semibold">{currentData.validity} Days</h5>
                <p className="text-muted">Validity Left</p>
            </div>
            <div className="progress animated-progress rounded-bottom rounded-0" style={{height: "6px"}}>
                <div className="progress-bar bg-success rounded-0" role="progressbar" style={{ width: "30%"}} aria-valuenow="30" aria-valuemin="0" aria-valuemax="100"></div>
                <div className="progress-bar bg-info rounded-0" role="progressbar" style={{ width: "50%" }} aria-valuenow="50" aria-valuemin="0" aria-valuemax="100"></div>
                <div className="progress-bar rounded-0" role="progressbar" style={{ width: "20%"}} aria-valuenow="20" aria-valuemin="0" aria-valuemax="100"></div>
            </div>
          </div>
      </div>
      <div className="col-lg-4">
        <div className="card">
            <div className="card-body">
                <h5 className="fs-16 fw-semibold">{currentData.active_devices}/{currentData.max_devices}</h5>
                <p className="text-muted">Devices</p>
            </div>
            <div className="progress animated-progress rounded-bottom rounded-0" style={{height: "6px"}}>
                <div className="progress-bar bg-success rounded-0" role="progressbar" style={{ width: "30%"}} aria-valuenow="30" aria-valuemin="0" aria-valuemax="100"></div>
                <div className="progress-bar bg-info rounded-0" role="progressbar" style={{ width: "50%" }} aria-valuenow="50" aria-valuemin="0" aria-valuemax="100"></div>
                <div className="progress-bar rounded-0" role="progressbar" style={{ width: "20%"}} aria-valuenow="20" aria-valuemin="0" aria-valuemax="100"></div>
            </div>
          </div>
      </div>
    </div>
  )
}

export default SubscriptionWidget